import * as go from 'gojs';

import { ArtificialLink } from 'src/containers/ProjectDiagram/templates/extensions/layouts/ForceDirectedLayout/types';

export const connectSubgraphs = (
  graphs: Array<Set<go.Node>>
): ArtificialLink[] => {
  const result: ArtificialLink[] = [];
  if (hasCentralGraph(graphs)) {
    // in case if there's a central graph, let's connect everything to it
    const centralGraph = findCentralGraph(graphs);
    const centralGraphCentralNode = findCentralNode(centralGraph);

    graphs.forEach((graph) => {
      if (graph === centralGraph) {
        return;
      }
      const centralNode = findCentralNode(graph);
      result.push({
        from: centralGraphCentralNode,
        to: centralNode,
      });
    });
  } else {
    // in the other case, just connect each graph to the previous one
    const centralNodes = new Map<number, go.Node>();
    graphs.forEach((graph, i) => {
      const centralNode = findCentralNode(graph);
      centralNodes.set(i, centralNode);

      if (i === 0) {
        return;
      }

      const from = centralNodes.get(i - 1);
      if (from) {
        result.push({
          from,
          to: centralNode,
        });
      }
    });
    // do a full circle by connecting first graph to last one, if there are more than 2 graphs
    if (graphs.length > 2) {
      const from = centralNodes.get(graphs.length - 1);
      const to = centralNodes.get(0);
      if (from && to) {
        result.push({
          from,
          to,
        });
      }
    }
  }
  return result;
};

const hasCentralGraph = (graphs: Array<Set<go.Node>>) => {
  if (graphs.length === 1) {
    return true;
  }
  for (let i = 1; i < graphs.length; i += 1) {
    if (graphs[i - 1].size !== graphs[i].size) {
      return false;
    }
  }
  return true;
};

const findCentralGraph = (graphs: Array<Set<go.Node>>) =>
  graphs.reduce(
    (previousValue, currentValue) =>
      previousValue.size < currentValue.size ? currentValue : previousValue,
    new Set()
  );

const findCentralNode = (nodes: Set<go.Node>) =>
  [...nodes].reduce<go.Node>(
    (previousValue, currentValue) =>
      !previousValue ||
      previousValue.findLinksConnected().filter((x) => !x.data.isEdgeProperty)
        .count <
        currentValue.findLinksConnected().filter((x) => !x.data.isEdgeProperty)
          .count
        ? currentValue
        : previousValue,
    null as any
  );
